export const DEFAULT_EXCHANGE_RATE = 1;
